import ThreeBadge from '../../content/assets/three-js-ico.png';

const technologies_tools = [
    {
        title: 'WINDOWS',
        source: 'https://user-images.githubusercontent.com/25181517/186884150-05e9ff6d-340e-4802-9533-2c3f02363ee3.png',
        alt: 'WINDOWS'
    },
    {
        title: 'UBUNTU',
        source: 'https://user-images.githubusercontent.com/25181517/186884153-99edc188-e4aa-4c84-91b0-e2df260ebc33.png',
        alt: 'UBUNTU'
    },
    {
        title: 'PYTHON',
        source: 'https://user-images.githubusercontent.com/25181517/183423507-c056a6f9-1ba8-4312-a350-19bcbc5a8697.png',
        alt: 'PYTHON'
    },
    {
        title: 'HTML5',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png',
        alt: 'HTML5'
    },
    {
        title: 'CSS3',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png',
        alt: 'CSS3'
    },
    {
        title: 'JAVASCRIPT',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png',
        alt: 'JAVASCRIPT'
    },
   
    {
        title: 'NODEJS',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png',
        alt: 'NODEJS'
    },
    {
        title: 'TYPESCRIPT',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/typescript/typescript.png',
        alt: 'TYPESCRIPT'
    },
    {
        title: 'WEBPACK',
        source: 'https://user-images.githubusercontent.com/25181517/187955008-981340e6-b4cc-441b-80cf-7a5e94d29e7e.png',
        alt: 'WEBPACK'
    },
    {
        title: 'SASS',
        source: 'https://user-images.githubusercontent.com/25181517/192158956-48192682-23d5-4bfc-9dfb-6511ade346bc.png',
        alt: 'SASS'
    },
    {
        title: 'NPM',
        source: 'https://user-images.githubusercontent.com/25181517/121401671-49102800-c959-11eb-9f6f-74d49a5e1774.png',
        alt: 'NPM'
    },
    {
        title: 'YARN',
        source: 'https://user-images.githubusercontent.com/25181517/183049794-a3dfaddd-22ee-4ffe-b0b4-549ccd4879f9.png',
        alt: 'YARN'
    },
    {
        title: 'BOOTSTRAP',
        source: 'https://user-images.githubusercontent.com/25181517/183898054-b3d693d4-dafb-4808-a509-bab54cf5de34.png',
        alt: 'BOOTSTRAP'
    },
    {
        title: 'VSCODE',
        source: 'https://user-images.githubusercontent.com/25181517/192108891-d86b6220-e232-423a-bf5f-90903e6887c3.png',
        alt: 'VSCODE'
    },
    {
        title: 'POSTMAN',
        source: ' https://user-images.githubusercontent.com/25181517/192109061-e138ca71-337c-4019-8d42-4792fdaa7128.png',
        alt: 'POSTMAN'
    },
    {
        title: 'JIRA',
        source: 'https://user-images.githubusercontent.com/25181517/183912952-83784e94-629d-4c34-a961-ae2ae795b662.png',
        alt: 'JIRA'
    },
    {
        title: 'GIT',
        source: 'https://user-images.githubusercontent.com/25181517/192108372-f71d70ac-7ae6-4c0d-8395-51d8870c2ef0.png',
        alt: 'GIT'
    },
    {
        title: 'GITHUB',
        source: 'https://user-images.githubusercontent.com/25181517/192108374-8da61ba1-99ec-41d7-80b8-fb2f7c0a4948.png',
        alt: 'GITHUB'
    },
    {
        title: 'GITLAB',
        source: 'https://user-images.githubusercontent.com/25181517/192108376-c675d39b-90f6-4073-bde6-5a9291644657.png',
        alt: 'GITLAB'
    },
    {
        title: 'BITBUCKET',
        source: 'https://user-images.githubusercontent.com/25181517/192108375-268c35e6-ab26-44b2-88bf-e3121a4e5083.png',
        alt: 'BITBUCKET'
    },
    {
        title: 'JENKINS',
        source: 'https://user-images.githubusercontent.com/25181517/179090274-733373ef-3b59-4f28-9ecb-244bea700932.png',
        alt: 'JENKINS'
    },
    {
        title: 'POSTGRESQL',
        source: 'https://user-images.githubusercontent.com/25181517/117208740-bfb78400-adf5-11eb-97bb-09072b6bedfc.png',
        alt: 'POSTGRESQL'
    },
    {
        title: 'MONGODB',
        source: 'https://user-images.githubusercontent.com/25181517/182884177-d48a8579-2cd0-447a-b9a6-ffc7cb02560e.png',
        alt: 'MONGODB'
    },
    {
        title: 'REST',
        source: 'https://user-images.githubusercontent.com/25181517/192107858-fe19f043-c502-4009-8c47-476fc89718ad.png',
        alt: 'REST'
    },
    {
        title: 'HTTP',
        source: 'https://user-images.githubusercontent.com/25181517/192107854-765620d7-f909-4953-a6da-36e1ef69eea6.png',
        alt: 'HTTP'
    },
    {
        title: 'REACT',
        source: 'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/react/react.png',
        alt: 'REACT'
    },
    {
        title: 'THREEJS',
        source: ThreeBadge,
        alt: 'THREEJS'
    },
    {
        title: 'PHP',
        source: "https://img.shields.io/badge/php-%23777BB4.svg?style=for-the-badge&logo=php&logoColor=white",
        alt: 'PHP'
    },
    {
        title: 'ANGULAR',
        source: 'https://img.shields.io/badge/angular-%23DD0031.svg?style=for-the-badge&logo=angular&logoColor=white"',
        alt: 'ANGULAR'
    },
]

export default technologies_tools;